<div class="h-12 w-1 bg-green-500 rounded-l-md">
</div>
<span class="p-2">
    {{data.message}}
</span>